export default __webpack_public_path__ + "static/media/LocandaMarco.6b3d9f21.jpg";